









































import { defineComponent, onMounted, toRefs, watch } from "@vue/composition-api";
import { debounce } from "lodash-es";
import { WelcomeMessage, WelcomeMessageType } from "@scrile/api-provider/dist/api/WelcomeMessagesProvider";
import BaseSwitch from "@/components/BaseSwitch";
import MessageEditorView from "@/components/MessageEditorView";
import SendMessageController from "@/components/SendMessageController";
import { useWelcomeMessage } from "./hooks/useWelcomeMessage";

const ADMIN_ID = "1";

export default defineComponent({
  name: "WelcomeMessageEditor",
  components: {
    SendMessageController,
    MessageEditorView,
    BaseSwitch,
  },
  props: {
    switcherTitle: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    subjectId: { type: String, default: "" },
    subjectType: {
      type: String as () => WelcomeMessage["subject"]["subjectType"],
      default: WelcomeMessageType.SUBSCRIBERS,
    },
  },
  setup(props, { emit }) {
    const { subjectId, subjectType } = toRefs(props);
    const {
      previewFiles,
      isShowEditor,
      nodeRef,
      value,
      loading,
      processing,
      pricePackageId,
      saveWelcomeMessage,
      updateAttachmentFiles,
      attachedFilesUpdate,
    } = useWelcomeMessage(subjectType, subjectId);

    const sendUpdateEvent = debounce(() => emit("updateWelcomeMessage"), 1000);

    onMounted(() => emit("saveWelcomeMessage", saveWelcomeMessage));

    watch([isShowEditor, previewFiles, pricePackageId], sendUpdateEvent);

    return {
      ADMIN_ID,
      value,
      nodeRef,
      previewFiles,
      isShowEditor,
      loading,
      processing,
      pricePackageId,
      updateAttachmentFiles,
      saveWelcomeMessage,
      attachedFilesUpdate,
      sendUpdateEvent,
    };
  },
});
